// Dependencies
import React from 'react';
import radium from 'radium';
import { connect } from 'react-redux';
import _ from 'lodash';

import LeoForm from '../../../components/form/LeoForm.jsx';
import LeoInput from '../../../components/form/LeoInput.jsx';
import LeoSelect from '../../../components/form/LeoReactSelect';
import countryEnum from '../../../lib/country-enum.js';
import validate from '../../../lib/email-validation.js';
import formService from '../../../lib/form-service.js';
import { ThemeContext } from "../../../components/theme/Theme.jsx";
import { getCountryCodeFromTheme } from "../../../redux/customerReducer";
import LeoLabel from "../../../components/form/LeoLabel";


const defaultProps = {
	address: {
		countryCode: getCountryCodeFromTheme(),
		salutation: '',
		firstname: '',
		lastname: '',
		additionalInfo: '',
		companyName: '',
		email: '',
		postalCode: '',
		city: '',
		street: '',
		houseNumber: '',
		phoneNumber: ''
	},
};


class AddressForm extends React.Component {
	static contextType = ThemeContext;
	constructor(props) {
		super(props);

		this.state = {
			eMailInfo: null,
		};

	}

	onEmailChange(e) {
		this.props.onChange(e);
		e.persist();
		if (!this.debounce) {
			this.debounce = _.debounce(() => {
				validate(formService.formatSpecificFieldValues(e.target.name, e.target.value))
					.then((msg) => this.setState({eMailInfo: msg}));
			}, 500);
		}
		this.debounce();
	}

	render() {
		const salutations = {
			MR: 'Herr',
			MS: 'Frau',
			COMPANY: 'Firma',
		};

		const additionalDropDownValuesString =
			this.context.themeManager.value('customer-address', 'customer-address-additional-dropdown_values', null);
		const additionalDropDownValues = additionalDropDownValuesString ? additionalDropDownValuesString.split('|') : null;
		const dropDownDefaultPlaceholder = this.context.themeManager.getThemeTextOrHardcodedDefault('dropDownPlaceholder');
		const additionalDropDownPlaceholder =
			this.context.themeManager.valueOrDefault('customer-address', 'customer-address-additional-dropdown_placeholder',
				dropDownDefaultPlaceholder);

		const countriesList = Object.entries(countryEnum)
			.sort((a, b) => a[1].localeCompare(b[1]));
		const address = Object.assign({}, this.props.address || defaultProps.address);
		return (
			<LeoForm id={this.props.type + "_address_form"}>
				<LeoLabel className={"visually-hidden"} id={this.props.type + "_salutation_label"} for={this.props.type + "_salutation"} label={'Anrede'}/>
				<LeoSelect
					id={this.props.type + "_salutation"}
					name="salutation"
					value={address.salutation}
					valueInput={salutations[address.salutation] ? salutations[address.salutation] : ''}
					onChange={this.props.onChange}
					placeholder="Anrede"
					options={
						Object.entries(salutations).map(([key, value]) => {
							return {
								value: key,
								label: value,
								isSelected: key === address.salutation,
							}
						})
					}
				>
				</LeoSelect>
				<LeoLabel className={"visually-hidden"} id={this.props.type + "_companyName_label"} for={this.props.type + '_companyName'} label={'Firma'}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={this.props.type + "_companyName"}
					name="companyName"
					value={address.companyName}
					onChange={this.props.onChange}
					placeholder="Firma"
					autoComplete={`${this.props.autoCompleteType} organization`}
					errors={formService.findAddressErrorForField(this.props.errors,'companyName', 'Firma')}
				/>
				{(this.props.showAdditionalDropDown && !this.props.hideAdditionalInfoForAddressForm) &&
					<>
						<LeoLabel className={"visually-hidden"} id={this.props.type + "_customer-address_additionalInfo_label"} for={this.props.type + '_customer-address_additionalInfo'} label={additionalDropDownPlaceholder}/>
						<LeoSelect
							id={this.props.type + "_customer-address_additionalInfo"}
							name="additionalInfo"
							value={address.additionalInfo ? address.additionalInfo : ''}
							valueInput={address.additionalInfo ? address.additionalInfo : ''}
							onChange={this.props.onChange}
							placeholder={additionalDropDownPlaceholder}
							errors={formService.findAddressErrorForField(this.props.errors,'additionalInfo', additionalDropDownPlaceholder.replace('*',''))}
							options={
								additionalDropDownValues.map((value) => {
									return {
										value: value,
										label: value,
										isSelected: value === address.countryCode,
									}
								})
							}
						>
						</LeoSelect>
					</>
				}
				<LeoLabel className={"visually-hidden"} id={this.props.type + "_firstname_label"} for={this.props.type + '_firstname'} label={"Vorname"}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={this.props.type + "_firstname"}
					name="firstname"
					value={address.firstname}
					onChange={this.props.onChange}
					placeholder="Vorname"
					autoComplete={`${this.props.autoCompleteType} given-name`}
					errors={formService.findAddressErrorForField(this.props.errors,'firstname', 'Vorname')}
				/>
				<LeoLabel className={"visually-hidden"} id={this.props.type + "_lastname_label"} for={this.props.type + '_lastname'} label={"Nachname *"}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={this.props.type + "_lastname"}
					name="lastname"
					value={address.lastname}
					onChange={this.props.onChange}
					placeholder="Nachname *"
					autoComplete={`${this.props.autoCompleteType} family-name`}
					errors={formService.findAddressErrorForField(this.props.errors,'lastname', 'Nachname')}
				/>
				<LeoLabel className={"visually-hidden"} id={this.props.type + "_phoneNumber_label"} for={this.props.type + '_phoneNumber'} label={"Telefon für Rückfragen *"}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={this.props.type + "_phoneNumber"}
					name="phoneNumber"
					value={address.phoneNumber}
					onChange={this.props.onChange}
					placeholder="Telefon für Rückfragen *"
					autoComplete={`${this.props.autoCompleteType} phone`}
					errors={formService.findAddressErrorForField(this.props.errors,'phoneNumber', 'Telefon für Rückfragen')}
				/>
				<LeoLabel className={"visually-hidden"} id={this.props.type + "_email_label"} for={this.props.type + '_email'} label={"Email *"}/>
				<LeoInput
					type="email"
					maxLength="255"
					id={this.props.type + "_email"}
					name="email"
					value={address.email}
					onChange={(e) => this.onEmailChange(e)}
					placeholder="Email *"
					autoComplete={`${this.props.autoCompleteType} email`}
					errors={formService.findAddressErrorForField(this.props.errors,'email', 'Email')}
					warn={!!this.state.eMailInfo}
					infoText={this.state.eMailInfo}
				/>
				<LeoLabel className={"visually-hidden"} id={this.props.type + "_postalCode_label"} for={this.props.type + '_postalCode'} label={"PLZ *"}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={this.props.type + "_postalCode"}
					name="postalCode"
					value={address.postalCode}
					onChange={this.props.onChange}
					placeholder="PLZ *"
					autoComplete={`${this.props.autoCompleteType} postal-code`}
					errors={formService.findAddressErrorForField(this.props.errors,'postalCode', 'PLZ')}
				/>
				<LeoLabel className={"visually-hidden"} id={this.props.type + "_city_label"} for={this.props.type + '_city'} label={"Ort *"}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={this.props.type + "_city"}
					name="city"
					value={address.city}
					onChange={this.props.onChange}
					placeholder="Ort *"
					autoComplete={`${this.props.autoCompleteType} address-level2`}
					errors={formService.findAddressErrorForField(this.props.errors,'city', 'Ort')}
				/>
				<LeoLabel className={"visually-hidden"} id={this.props.type + "_street_label"} for={this.props.type + '_street'} label={"Straße *"}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={this.props.type + "_street"}
					name="street"
					value={address.street}
					onChange={this.props.onChange}
					placeholder="Straße *"
					autoComplete={`${this.props.autoCompleteType} new-address-level3`}
					errors={formService.findAddressErrorForField(this.props.errors,'street', 'Straße')}
				/>
				<LeoLabel className={"visually-hidden"} id={this.props.type + "_houseNumber_label"} for={this.props.type + '_houseNumber'} label={"Hausnummer *"}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={this.props.type + "_houseNumber"}
					name="houseNumber"
					value={address.houseNumber}
					onChange={this.props.onChange}
					placeholder="Hausnummer *"
					autoComplete={`${this.props.autoCompleteType} new-address-level4`}
					errors={formService.findAddressErrorForField(this.props.errors,'houseNumber', 'Hausnummer')}
				/>
				<LeoLabel className={"visually-hidden"} id={this.props.type + "_country_label"} for={this.props.type + '_countryCode'} label={'Land'}/>
				<LeoSelect
					id={this.props.type + "_countryCode"}
					name="countryCode"
					value={address.countryCode}
					placeholder={'Land'}
					valueInput={countryEnum[address.countryCode] ? countryEnum[address.countryCode] : ''}
					onChange={this.props.onChange}
					options={
						countriesList.map(([key, value]) => {
							return {
								value: key,
								label: value,
								isSelected: key === address.countryCode,
							}
						})
					}
				>
				</LeoSelect>
			</LeoForm>
		);
	}
}


const mapStateToProps = (state) => {
	const showAdditionalDropDown = state.customer.showCustomerAddressAdditionalDropDown;
	return {
		showAdditionalDropDown,
	};
};

const RadiumAddressForm = radium(AddressForm);

export default connect(
	mapStateToProps,
)(RadiumAddressForm);
